 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Claim
    <v-spacer></v-spacer>
    <v-btn text icon @click="closeDialog">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryClmFilterForm">
          <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 xs12>
                        <v-text-field data-vv-scope="queryClmFilterForm" v-model="filtersClm.claimNo" :label="filtersClmLabel.claimNo" :error-messages="errors.collect('filterClm')" data-vv-name="filterClm" :data-vv-as="filtersClmLabel.claimNo" v-validate="'entry|max:20'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions right>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearClmFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text @click.prevent="doClmFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-data-table :headers="clmHeaders" :items="clmItems" v-bind:options.sync="paginationClm" :footer-props="{'items-per-page-options': itemsPerPage }" :server-items-length="totalItemsClm" :loading="loading" class="elevation-1" :no-data-text="noDataText">
            <template v-slot:item="row"><tr>
              <td>{{ row.item.clmNo}}</td>
              <td>{{ row.item.polNo}}</td>
              <td>{{ row.item.renCnt }}</td>
              <td style="text-align:center">
                <v-btn text icon color="primary" type="submit" @click="assignClaimNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
             </tr></template>
            </v-data-table>
        </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      clmItems: [],
      totalItemsClm: 0,
      filtersClmLabel: {
        claimNo: 'Claim No.'
      },
      filtersClm: {
        claimNo: undefined,
        accountNo: null
      },
      clmHeaders: [
        { text: 'Claim No.', align: 'left', value: 'claimNo' },
        { text: 'Policy No.', align: 'left', value: 'policyNo' },
        { text: 'Ren Cnt', align: 'left', value: 'renCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationClm: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
  },
  watch: {
    'boolRefresh': function(value) {
      if (value) {
        this.doClearClmFilters()
      }
    },
    'paginationClm': function (value) {
      this.fetchClmData()
    }
  },
  methods: {
    doFilterOnEnter() {
      this.doClmFilters()
      event.preventDefault()
    },
    closeDialog() {
      this.filtersClm.claimNo = ''
      this.$emit('close')
    },
    doClearClmFilters() {
      this.filtersClm.claimNo = ''
      this.filtersClm.accountNo = this.accountNo
      this.fetchClmData()
    },
    doClmFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryClmFilterForm').then(result => {
        if (result) {
          this.paginationClm.page = 1
          this.filtersClm.accountNo = this.accountNo
          this.fetchClmData()
        }
      })
    },
    assignClaimNo(data) {
      // Use $emit to call parent Accounts page method assignClaimNo and pass the value
      this.$emit('assign-claim-no', data.clmNo)
      this.$emit('assign-claim-info', data)
      this.$emit('close')
    }
  },
  computed: {
  },
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    accountNo: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    commonAjaxMixin
  ]
}
</script>
